import app from 'flarum/forum/app';
import Notification from 'flarum/forum/components/Notification';

export default class TradeSubscriptionMatchNotification extends Notification {
  icon() {
    return 'fas fa-bell';
  }

  href() {
    return app.route('acme.badminton.trades');
  }

  content() {
    const notification = this.attrs.notification;
    const data = notification.content() || {};
    const summary = data.summary != null ? String(data.summary) : '';
    const from = notification.fromUser();
    const username = from ? from.displayName() : app.translator.trans('core.lib.username.deleted_text');

    return app.translator.trans('acme-pku-badminton.forum.notifications.trade_subscription_match_text', {
      username,
      summary,
    });
  }
}
